import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from './store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

/**
 * All top-level keys in the Redux store.
 * Use this type when a component receives a dynamic slice name as a prop.
 */
export type SliceKey = keyof RootState;

/**
 * Access a dynamic slice from RootState.
 * Returns Record<string, unknown> — callers must narrow or assert the field type.
 * Eliminates `as Record<string, any>` casts throughout the codebase.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectSlice = (state: RootState, key: string): Record<string, any> =>
  state[key as SliceKey] as never;
